import React, { Suspense, useEffect } from 'react';
import { ThemeProvider } from '@getgo/chameleon-web/react';
import { RegistrationWrapper } from './component/context/registrationContext';
import { EventWrapper } from './component/context/eventContext';
import { ConferenceWrapper } from './component/context/conferenceContext';
import { UserWrapper } from './component/context/userContext';
import RouterApp from './routerApp';
import { initializeMixpanel } from './mixpanel/mixpanelClient';
import FullScreenLoader from './component/utils/fullScreenLoader/FullScreenLoader';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Deprecated: Remove ThemeProvider from chameleon-chakra-ui

function App() {
  const { rebranding } = useFlags();
  initializeMixpanel();

  useEffect(() => {
    const favIcon = document.querySelector("link[rel='icon']");
    const favAppleIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (favIcon instanceof HTMLLinkElement) {
      favIcon.href = !rebranding ? '/faviconOld.ico' : '/images/favicon.ico';
      if (favAppleIcon instanceof HTMLLinkElement) {
        favAppleIcon.href = !rebranding ? '/faviconOld.ico' : '/images/faviconApple.png';
      }
      document.title = !rebranding ? 'GoToWebinar' : 'GoTo Webinar';
    }
  }, [rebranding]);
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme="light" style={{ height: '100vh' }} rebranding2021>
          <EventWrapper>
            <UserWrapper>
              <RegistrationWrapper>
                <ConferenceWrapper>
                  <RouterApp />
                </ConferenceWrapper>
              </RegistrationWrapper>
            </UserWrapper>
          </EventWrapper>
        </ThemeProvider>
      </I18nextProvider>
    </Suspense>
  );
}

export default App;
